import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys, pickProperties } from '../utils';
import { authenticationService } from './service';
import { IViewTradingAccountBalances, IViewTradingAccountDetails } from './types';

export const useAuthentication = () => useService(authenticationService, (context) => context);
export const useAuthenticationLoading = () => useService(authenticationService, (context) => context.loading);
export const useAuthenticationExperienceTokenLoading = () =>
  useService(authenticationService, (context) => context.experienceTokenLoading);
export const useAuthenticationAuthenticated = () =>
  useService(authenticationService, (context) => context.authenticated);
export const useAuthenticationWithKeys = getUseServiceWithSubscriptionKeys(authenticationService);

export const useAccountBalances = () =>
  useService(authenticationService, (context) => context.selectedTradingAccountBalances);

export const useAccountDetails = () =>
  useService(authenticationService, (context) => context.selectedTradingAccountDetails);

export const useAccountDetailsWithKeys = (keys: (keyof IViewTradingAccountDetails)[]) =>
  useService(authenticationService, (context) => pickProperties(context.selectedTradingAccountDetails || {}, keys));

export const useSelectedTradingAccountId = () =>
  useService(authenticationService, (context) => context.selectedTradingAccountDetails?.accountId);

export const useAuthLoading = () => useService(authenticationService, (context) => context.authLoading);

export const useAuthLoginAs = () => useService(authenticationService, (context) => context.loginAs);

export const useAuthLoginSource = () => useService(authenticationService, (context) => context.source);

export const useAuthLoginErrorCode = () => useService(authenticationService, (context) => context.loginErrorCode);

export const usePrefilledLoginDetails = () => useService(authenticationService, (context) => context.prefilledLogin);

export const useAccountBalancesWithKeys = (keys: (keyof IViewTradingAccountBalances)[]) =>
  useService(authenticationService, (context) => pickProperties(context.selectedTradingAccountBalances || {}, keys));

export const useTradingAccounts = () => useService(authenticationService, (context) => context.tradingAccounts ?? []);

export const useIsAccountReadOnly = () =>
  useService(authenticationService, (context) => context.selectedTradingAccountDetails?.readOnly === 1);

export const useIsViewOnly = () =>
  useService(authenticationService, (context) => context.selectedTradingAccountDetails?.viewOnly);

export const useNotificationTopics = () =>
  useService(authenticationService, (context) => context.userDetails?.notificationTopics);

export const useAccountCrmType = () => useService(authenticationService, (context) => context.userDetails?.crmType);

export const useUserDetails = () => useService(authenticationService, (context) => context.userDetails);
